/*
  Toggle logic for the hardcoded FAQ accordion (.acc-wrap) in main-product.liquid.
  Extracted from an inline <script> so it loads deferred and cached instead of
  running synchronously during HTML parse.
*/
(function () {
  function initAccordions() {
    document.querySelectorAll('.acc-wrap').forEach(function (wrap) {
      wrap.querySelectorAll('.acc-header').forEach(function (h) {
        h.addEventListener('click', function () {
          var item = h.parentElement;
          var isActive = item.classList.contains('active');
          wrap.querySelectorAll('.acc-item').forEach(function (i) {
            i.classList.remove('active');
          });
          if (!isActive) item.classList.add('active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }
})();

/* Click-to-load UGC videos. Shopify-hosted video sources stay inside a
   <template> until the shopper presses Play, so they add no initial request. */
(function () {
  if (window.amueeProductUgcReady) return;
  window.amueeProductUgcReady = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-product-ugc-play]');
    if (!button) return;

    var player = button.closest('[data-product-ugc-player]');
    var template = player && player.querySelector('[data-product-ugc-template]');
    if (!player || !template) return;

    var content = template.content.cloneNode(true);
    button.remove();
    template.remove();
    player.appendChild(content);

    var video = player.querySelector('video');
    if (video) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
    }
  });

  /* The media column is the right home for these videos on desktop, but it puts
     them between the gallery and the buying controls on mobile. Move the same
     nodes (not clones) immediately before the review section on small screens. */
  var mobileUgcQuery = window.matchMedia('(max-width: 749px)');

  function followingReviews(ugc) {
    var reviewRoots = document.querySelectorAll('.amrv-root');
    for (var i = 0; i < reviewRoots.length; i++) {
      if (ugc.compareDocumentPosition(reviewRoots[i]) & Node.DOCUMENT_POSITION_FOLLOWING) {
        return reviewRoots[i].closest('.shopify-section') || reviewRoots[i];
      }
    }
    return null;
  }

  function placeUgcVideos() {
    document.querySelectorAll('.product-ugc').forEach(function (ugc) {
      if (!ugc._amueeHomeMarker) {
        ugc._amueeHomeMarker = document.createComment('product-ugc-home');
        ugc.parentNode.insertBefore(ugc._amueeHomeMarker, ugc);
      }

      if (mobileUgcQuery.matches) {
        var reviews = followingReviews(ugc);
        if (!reviews || !reviews.parentNode) return;
        ugc.setAttribute('data-mobile-relocated', 'true');
        reviews.parentNode.insertBefore(ugc, reviews);
      } else if (ugc._amueeHomeMarker.parentNode) {
        ugc.removeAttribute('data-mobile-relocated');
        ugc._amueeHomeMarker.parentNode.insertBefore(ugc, ugc._amueeHomeMarker.nextSibling);
      }
    });
  }

  placeUgcVideos();
  if (typeof mobileUgcQuery.addEventListener === 'function') {
    mobileUgcQuery.addEventListener('change', placeUgcVideos);
  } else {
    mobileUgcQuery.addListener(placeUgcVideos);
  }
  document.addEventListener('shopify:section:load', placeUgcVideos);
})();